import {
  browserFastApiClient,
  requireFastApiAccessToken,
} from "@/core/fastapi";
import {
  identifyTopicsApiService,
  type IdentifyTopicsRequest,
  type IdentifyTopicsResponse,
} from "@/generated/fastapi";

export async function identifyTopics(
  accessToken: string | null | undefined,
  request: IdentifyTopicsRequest,
): Promise<IdentifyTopicsResponse> {
  const response = await identifyTopicsApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error("Failed to identify topics");
  }

  return response.data;
}
